<template>
  <div ref="form">
    <fieldset class="border flex-space">
      <div>
        <span class="bold fs15">Hub: {{ hub }}&nbsp;</span>
        <i class="el-icon-plus" />
        <slot v-for="(item, index) in newPopups">
          <el-divider v-if="index != 0" direction="vertical" />
          <popup
            componentPath="components/html"
            width="760px"
            :pivot-y="0"
            :options="{ title: `New ${item.type}`, url: item.url }"
            @closed="item.callback"
            :key="index"
          >
            <el-button size="mini" type="text">{{ item.type }}</el-button>
          </popup>
        </slot>
      </div>
    </fieldset>
    <div class="e-form pt5">
      <el-form
        label-position="top"
        ref="form"
        :model="bol"
        size="mini"
        class="flex flex-col gap-1"
      >
        <div>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item
                required
                label="Customer"
                :error="errors.customer_id"
              >
                <el-select
                  filterable
                  clearable
                  v-model="bol.customer_id"
                  placeholder="choose customer"
                  class="full-width"
                  :disabled="bol.scheduled"
                >
                  <el-option
                    v-for="item in options.customers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="BOL No.">
                <el-input
                  v-model="bol.reference_no"
                  placeholder="Auto if Empty"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Pickup Date" :error="errors.pickup_date">
                <el-date-picker
                  v-model="bol.pickup_date"
                  type="date"
                  :value-format="'yyyy-MM-dd'"
                  class="full-width"
                  @change="syncDueDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Due Date">
                <el-date-picker
                  v-model="bol.due_date"
                  type="date"
                  :value-format="'yyyy-MM-dd'"
                  class="full-width"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item
                required
                label="Billing Type"
                :error="errors.billing_type"
              >
                <el-select v-model="bol.billing_type">
                  <el-option
                    v-for="item in options.billingTypes"
                    :key="item.name"
                    :label="item.title"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item required label="Origin" :error="errors.origin_id">
                <el-select
                  filterable
                  clearable
                  remote
                  :remote-method="queryOrigins"
                  v-model="bol.origin_id"
                  placeholder="name/street (min 3 letters)"
                  class="full-width"
                  :disabled="bol.scheduled"
                >
                  <el-option-group
                    v-for="(items, label) in options.origins"
                    :key="label"
                    :label="label"
                  >
                    <el-option
                      v-for="item in items"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      class="two-lines"
                    >
                      <div class="title-1 flex-space">
                        <div>{{ item.name }}</div>
                        <a
                          @click.prevent="editCompany(item.id)"
                          class="el-icon-edit-outline"
                        ></a>
                      </div>
                      <div class="title-2">{{ item.address }}</div>
                    </el-option>
                  </el-option-group>
                </el-select>
                <div class="hint">{{ originAddress }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                required
                label="Destination"
                :error="errors.destination_id"
              >
                <el-select
                  filterable
                  clearable
                  remote
                  :remote-method="queryDestinations"
                  v-model="bol.destination_id"
                  placeholder="name/street (min 3 letters)"
                  class="full-width"
                  :disabled="bol.scheduled"
                >
                  <el-option-group
                    v-for="(items, label) in options.destinations"
                    :key="label"
                    :label="label"
                  >
                    <el-option
                      v-for="item in items"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      class="two-lines"
                    >
                      <div class="title-1 flex-space">
                        <div>{{ item.name }}</div>
                        <a
                          @click.prevent="editCompany(item.id)"
                          class="el-icon-edit-outline"
                        ></a>
                      </div>
                      <div class="title-2">{{ item.address }}</div>
                    </el-option>
                  </el-option-group>
                </el-select>
                <div class="hint">{{ destAddress }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Pickup Remarks">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="bol.pickup_remarks"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Delivery Remarks">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="bol.delivery_remarks"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="flex flex-col gap-1 empty:hidden">
          <div class="receivable-charges" v-if="$store.envs.access_receivable">
            <charge-form
              type="receivable"
              target="Bol"
              :items="bol.receivable_charges"
              :errors="receivableChargeErrors"
              key="receivable"
            />
          </div>
          <div class="payable-charges" v-if="$store.envs.access_payable">
            <charge-form
              type="payable"
              target="Bol"
              :items="bol.payable_charges"
              :errors="payableChargeErrors"
              key="payable"
            />
          </div>
        </div>
        <div class="border-2 border-sky-400 relative">
          <div
            class="flex items-center justify-between bg-white border-b h-12 px-3"
          >
            <div class="flex items-center">
              <div
                class="show-hide font-semibold text-base w-40"
                rel="carrier-items"
              >
                <i class="gray icon icons-min" />&nbsp;Carrier Items
              </div>
              <div class="flex items-center gap-2">
                <a class="no-underline" @click="newCarrierItem"
                  ><i class="fas fa-plus-circle" />&nbsp;Item</a
                >
              </div>
            </div>
          </div>
          <div id="carrier-items">
            <table class="tbl text-2xs">
              <thead>
                <tr>
                  <th width="25">#</th>
                  <th width="90" class="required">
                    <el-tooltip
                      v-if="carrierItemErrors.stype"
                      :content="carrierItemErrors.stype"
                      placement="top"
                      class="red"
                    >
                      <span>Type</span>
                    </el-tooltip>
                    <slot v-else>Type</slot>
                  </th>
                  <th class="required">
                    <el-tooltip
                      v-if="carrierItemErrors.commodity"
                      :content="carrierItemErrors.commodity"
                      placement="top"
                      class="red"
                    >
                      <span>Commodity</span>
                    </el-tooltip>
                    <slot v-else>Commodity</slot>
                  </th>
                  <th width="60">
                    <el-tooltip
                      v-if="carrierItemErrors.pieces"
                      :content="carrierItemErrors.pieces"
                      placement="top"
                      class="red"
                    >
                      <span>PCS</span>
                    </el-tooltip>
                    <slot v-else>PCS</slot>
                  </th>
                  <th width="60">Stackable</th>
                  <th width="60">W(in)</th>
                  <th width="60">L(in)</th>
                  <th width="60">H(in)</th>
                  <th width="80">QTY</th>
                  <th width="90">
                    <el-tooltip
                      v-if="carrierItemErrors.weight"
                      :content="carrierItemErrors.weight"
                      placement="top"
                      class="red"
                    >
                      <span>W(lbs)</span>
                    </el-tooltip>
                    <slot v-else>W(lbs)</slot>
                  </th>
                  <th width="75">Frt. Class</th>
                  <th width="40">DEL.</th>
                </tr>
              </thead>
              <draggable
                v-model="bol.carrier_items"
                tag="tbody"
                handle=".seq-handle"
                @change="changeCarrierItemMark(tl.carrier_items)"
              >
                <tr v-for="(item, index) in bol.carrier_items" :key="index">
                  <td>
                    <a class="seq-handle">{{ item.mark }}</a>
                  </td>
                  <td>
                    <el-select
                      filterable
                      clearable
                      v-model="item.stype"
                      class="full-width"
                      size="mini"
                    >
                      <el-option
                        v-for="stype in options.stypes"
                        :key="stype.name"
                        :label="stype.title"
                        :value="stype.name"
                      />
                    </el-select>
                  </td>
                  <td>
                    <el-input v-model="item.commodity" size="mini"></el-input>
                  </td>
                  <td>
                    <el-input
                      v-model="item.pieces"
                      size="mini"
                      class="text-center"
                    ></el-input>
                  </td>
                  <td>
                    <center>
                      <el-checkbox v-model="item.stackable" />
                    </center>
                  </td>
                  <td>
                    <el-input
                      v-model="item.width"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      v-model="item.length"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      v-model="item.height"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      v-model="item.qty"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      v-model="item.weight"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      v-model="item.freight_class"
                      size="mini"
                      class="text-center"
                    ></el-input>
                  </td>

                  <td>
                    <el-checkbox
                      v-model="item._destroy"
                      :disabled="item.operated"
                    ></el-checkbox>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
        </div>
        <div class="flex-start">
          <el-form-item>
            <div class="flex items-center gap-2 my-1">
              <el-button type="primary" @click="saveBol"
                >Save Bill of Lading</el-button
              >
              <div class="flex items-center" v-if="!id">
                <el-input-number
                  v-model="batch"
                  :step="1"
                  :min="1"
                  :max="99"
                  style="width: 100px"
                />
                <label class="border bg-white px-2">Batch QTY</label>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <BolTrips :id="id" v-if="id > 0"></BolTrips>
  </div>
</template>
<script>
import EHtml from "@/default/components/html.vue";
import BolTrips from "@/default/pages/bols/trips.vue";

export default {
  name: "BolForm",
  components: {
    BolTrips,
    EHtml,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    hub: {
      type: String,
    },
  },
  data() {
    return {
      options: {
        customers: [],
        places: {},
        origins: {},
        destinations: {},
        billingTypes: [],
        stypes: [],
        chassisStencils: [],
        chassisTypes: [],
      },
      bol: {
        billing_type: "col",
        carrier_items: [],
        receivable_charges: [],
        payable_charges: [],
      },
      activeItem: null,
      companyId: null,
      batch: 1,
      trips: [],
      errors: {},
    };
  },
  async created() {
    await this.loadOptions();
    await this.loadBol();
    await this.loadCustomers();
  },
  watch: {
    customerId(nv, ov) {
      if (window.ReceivableChargeForm) ReceivableChargeForm.setCustomerId(nv);
    },
  },
  computed: {
    turboFrame() {
      return this.$refs.form.closest("turbo-frame");
    },
    newPopups() {
      const groups = [];
      groups.push({
        type: "Customer",
        url: `/customers/new?title_bar=false`,
        callback: this.loadCustomers,
      });
      groups.push({
        type: "Terminal",
        url: `/terminals/new?title_bar=false`,
        callback: () => {},
      });
      groups.push({
        type: "Warehouse",
        url: `/warehouses/new?title_bar=false`,
        callback: () => {},
      });
      groups.push({
        type: "Yard",
        url: `/yards/new?title_bar=false`,
        callback: () => {},
      });
      groups.push({
        type: "Place",
        url: `/places/new?title_bar=false`,
        callback: () => {},
      });

      return groups;
    },
    customerId() {
      return this.bol.customer_id;
    },
    originAddress() {
      return (
        Object.values(this.options.origins)
          .flat()
          .find((o) => o.id == this.bol.origin_id) || {}
      ).address;
    },
    destAddress() {
      return (
        Object.values(this.options.destinations)
          .flat()
          .find((o) => o.id == this.bol.destination_id) || {}
      ).address;
    },
    isOperated() {
      return this.trips.filter((o) => o.operated_at).length > 0;
    },
    carrierItemErrors() {
      return this.errors.carrier_items || {};
    },
    receivableChargeErrors() {
      return this.errors.receivable_charges || {};
    },
    payableChargeErrors() {
      return this.errors.payable_charges || {};
    },
  },
  methods: {
    async loadOptions() {
      try {
        const { data } = await this.$http.get("/api/v1/options.json", {
          params: {
            targets: ["bols", "chassis_stencils", "chassis_types"],
          },
        });
        this.options.billingTypes = data.bols.billing_types;
        this.options.stypes = data.bols.stypes;
        this.options.chassisStencils = data.chassis_stencils;
        this.options.chassisTypes = data.chassis_types;
      } catch (ex) {}
    },
    async loadCustomers() {
      try {
        const response = await this.$http.get("/api/v1/options.json", {
          params: {
            target: "customers",
            active: true,
            id: this.customerId,
          },
        });
        this.options.customers = response.data;
      } catch (ex) {}
    },
    syncDueDate() {
      this.$set(this.bol, "due_date", this.bol.pickup_date);
    },
    async queryOrigins(string) {
      const name = string.trim();
      if (name.length >= 3) {
        try {
          const response = await this.$http.get("/api/v1/bols/places", {
            params: { name },
          });
          this.$set(this.options, "origins", response.data);
        } catch (err) {}
      }
    },
    async queryDestinations(string) {
      const name = string.trim();
      if (name.length >= 3) {
        try {
          const response = await this.$http.get("/api/v1/bols/places", {
            params: { name },
          });
          this.$set(this.options, "destinations", response.data);
        } catch (err) {}
      }
    },
    async reloadCompany() {
      try {
        const response = await this.$http.get(
          `/api/v1/companies/${this.companyId}?mode=address`,
        );
        this.replaceCompany(this.options.origins, response.data);
        this.replaceCompany(this.options.destinations, response.data);
        this.resetCompanySelect(this.bol, "origin_id");
        this.resetCompanySelect(this.bol, "destination_id");
      } catch (err) {}
    },
    replaceCompany(groups, data) {
      for (const [type, items] of Object.entries(groups)) {
        let index = items.findIndex((o) => o.id == this.companyId);
        if (index >= 0) groups[type].splice(index, 1, data);
      }
    },
    resetCompanySelect(item, attr) {
      let value = item[attr];
      this.$set(item, attr, 0);
      setTimeout(() => {
        this.$set(item, attr, value);
      }, 100);
    },
    async loadBol() {
      try {
        if (this.id > 0) {
          const response = await this.$http.get(`/api/v1/bols/${this.id}`);
          this.bol = response.data;
          this.options.origins = this.bol.origins;
          this.options.destinations = this.bol.destinations;
        }
      } catch (ex) {}
    },
    async saveBol() {
      this.errors = [];
      const func = this.id > 0 ? this.$http.put : this.$http.post;
      const url = this.id > 0 ? `/api/v1/bols/${this.id}` : `/api/v1/bols`;
      let record = Object.assign({}, this.bol);
      record = this.nestedAttrs(record, "carrier_items");
      record = this.nestedAttrs(record, "receivable_charges", "key");
      record = this.nestedAttrs(record, "payable_charges", "key");
      try {
        const response = await func(url, { bol: record, batch: this.batch });
        const data = response.data;
        if (Array.isArray(data)) {
          if (window.parent.BolList)
            data.forEach((item) => window.parent.BolList.syncItem(item));
          this.close();
        } else {
          if (window.parent.BolList) window.parent.BolList.syncItem(data);
          if (this.turboFrame) {
            let url = `/bols/${data.id}?frame=${this.turboFrame.id}&layout=empty`;
            this.turboFrame.setAttribute("src", url);
          } else {
            window.location.href = `/bols/${data.id}`;
          }
        }
        if (window.parent.LtlList) window.parent.LtlList.reload();
      } catch (err) {
        console.log(err);
        this.errors = err.response.data.errors;
        window.scroll(0, 45);
      }
    },
    newCarrierItem() {
      const num = this._.max(this.bol.carrier_items.map((o) => o.mark));
      const mark = num ? parseInt(num) + 1 : 1;
      this.bol.carrier_items.push({ stype: null, mark });
    },
    changeCarrierItemMark(items) {
      items.forEach((item, index) => {
        item.mark = index + 1;
      });
    },
    async calcNmfc(item) {
      const { width, length, height, qty, weight } = item;
      const empties = [width, length, height, qty, weight].filter((o) =>
        this.isEmptyData(o),
      );
      if (empties.length == 0) {
        try {
          const response = await this.$http.post(
            "/api/v1/carrier_items/nmfc.json",
            { carrier_item: item },
          );
          this.$set(item, "freight_class", response.data);
        } catch (err) {}
      }
    },
    editCompany(id) {
      this.companyId = id;
      this.$modal.show(
        EHtml,
        {
          title: "Editing Company",
          url: `/companies/${id}/edit?title_bar=false`,
        },
        {
          width: 760,
          height: "100%",
          draggable: true,
        },
        {
          closed: this.reloadCompany,
        },
      );
    },
    readTrips(trips) {
      this.trips = trips;
    },
    close() {
      if (this.turboFrame) {
        const popupForm = this.$refs.form.closest(".popup-form");
        if (popupForm) popupForm.setAttribute("close-confirmed", true);
        Dialog.close();
      } else {
        window.location.href = "/truckload";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a.seq-handle {
  @apply block no-underline mx-auto bg-gray-500 text-white border rounded-2xl w-4 h-4 text-center text-2xs font-bold;
}
</style>
